import { Box, Button, OutlinedInput, useTheme } from '@mui/material';
import { FC } from 'react';

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const MAX_QUERY_LENGTH = 150;

interface Props {
  onSearch: (query: string) => void;
  defaultValue?: string | null;
}

const RecommendationForm: FC<Props> = ({ onSearch, defaultValue }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const { register, handleSubmit, formState } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      query: defaultValue,
    },
  });

  const { isValid } = formState;

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(({ query }) => query && onSearch(query))}
      data-testid="recommendation-form"
      sx={{
        display: 'grid',
        gridTemplate: {
          xs: '1fr 1fr / 1fr',
          md: '1fr / auto 10rem',
        },
        gridGap: '1rem',
      }}
    >
      <OutlinedInput
        id="recommendation-query-form"
        notched={false}
        required
        {...register('query', { required: true })}
        error={!isValid}
        autoComplete="false"
        sx={{
          flexGrow: 1,
          backgroundColor: theme.palette.grey[50],
          borderRadius: 4,
          fontSize: 18,
          color: theme.palette.grey[900],
        }}
        inputProps={{ maxLength: MAX_QUERY_LENGTH }}
      />
      <Button
        type="submit"
        color="primary"
        data-testid="saveButton"
        variant="rounded"
        disabled={!isValid}
        sx={{
          fontSize: '1.1rem',
          borderRadius: '0.25rem',
        }}
      >
        {t('aiRecommendations:form:getRecommendations')}
      </Button>
    </Box>
  );
};

export default RecommendationForm;
